import React from "react";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal } from "./Reveal";
import { buildWhatsAppLink } from "../lib/constants";

export const CTASection = () => {
  const { t } = useLang();
  return (
    <section data-testid="cta-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal className="relative overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-[#0047ff] to-[#03153a] p-10 md:p-20 text-center noise-overlay">
          <div className="absolute -top-24 -left-24 h-72 w-72 blue-glow opacity-80" />
          <div className="absolute inset-0 grid-lines opacity-20" />
          <div className="relative">
            <h2 className="mx-auto max-w-3xl font-display text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-white">
              {t.cta.title}
            </h2>
            <p className="mx-auto mt-6 max-w-2xl text-base md:text-lg font-light text-blue-100/90">
              {t.cta.text}
            </p>
            <a
              data-testid="cta-button"
              href={buildWhatsAppLink(t.cta.whatsappMsg)}
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-10 inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 py-4 text-base font-semibold text-[#04122e] hover:bg-zinc-100 transition-[background-color,transform] duration-300 hover:-translate-y-0.5"
            >
              {t.cta.button}
              <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
